var _path, _rect, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplitIconGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9294 8.51817L20.371 11.1428L14.8276 11.1254C14.3702 11.1254 14 11.5232 14 12.0148C14 12.5046 14.3702 12.9041 14.8276 12.9041L20.3128 12.9215L17.9294 15.4818C17.607 15.8293 17.607 16.3921 17.9294 16.7395C18.2527 17.0868 18.7772 17.0868 19.1005 16.7395L22.5062 13.0796C22.806 12.8363 23 12.449 23 12.0148C23 11.676 22.8836 11.3686 22.6913 11.1341C22.667 11.0993 22.6404 11.0664 22.6113 11.035L19.1005 7.26054C18.7772 6.91315 18.2527 6.91315 17.9294 7.26054C17.607 7.60792 17.607 8.1707 17.9294 8.51817Z",
    fill: "#d9d9d9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 2,
    height: 16,
    rx: 1,
    fill: "#d9d9d9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.07058 8.51817L3.62904 11.1428L9.17241 11.1254C9.62982 11.1254 10 11.5232 10 12.0148C10 12.5046 9.62982 12.9041 9.17241 12.9041L3.68723 12.9215L6.07058 15.4818C6.39305 15.8293 6.39305 16.3921 6.07058 16.7395C5.74731 17.0868 5.22279 17.0868 4.89951 16.7395L1.4938 13.0796C1.19397 12.8363 1 12.449 1 12.0148C1 11.676 1.11638 11.3686 1.30873 11.1341C1.33297 11.0993 1.35964 11.0664 1.38874 11.035L4.89951 7.26054C5.22279 6.91315 5.74731 6.91315 6.07058 7.26054C6.39305 7.60792 6.39305 8.1707 6.07058 8.51817Z",
    fill: "#d9d9d9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 16,
    rx: 1,
    transform: "matrix(-1 0 0 1 16 4)",
    fill: "#d9d9d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplitIconGray);
export default __webpack_public_path__ + "static/media/splitIconGray.5a6bab7b37b9903441af664ec16321e9.svg";
export { ForwardRef as ReactComponent };